import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';

@Pipe({ name: 'airlineImg', standalone: true })
export class AirlineImgPipe implements PipeTransform {
  transform(
    value?: string,
    options?: { defaultUrl?: string; flightCode?: string; isLocal?: boolean },
  ): string {
    const imgUrl = options?.defaultUrl ?? `${environment.cdnUrl}/airlines`;
    const flightCode = options?.flightCode;
    const isLocal = options?.isLocal ?? true;

    if (flightCode) {
      // BLxxx => Pacific Airlines
      if (flightCode.toLowerCase().startsWith('bl')) {
        return `${imgUrl}/bl.gif`;
      }

      // Domestic flights: VN6xxx (4 digits) => Pacific Airlines (BL)
      if (
        isLocal &&
        flightCode.toLowerCase().startsWith('vn6') &&
        /^\d{4}$/.test(flightCode.slice(2))
      ) {
        return `${imgUrl}/bl.gif`;
      }

      // International flights: VN6xx (3 digits) => Vietnam Airlines (VN)
      if (
        !isLocal &&
        flightCode.toLowerCase().startsWith('vn6') &&
        /^\d{3}$/.test(flightCode.slice(2))
      ) {
        return `${imgUrl}/vn.gif`;
      }
    }

    switch (value?.toLowerCase()) {
      case 'vn':
        return `${imgUrl}/vn.gif`;
      case 'vj':
        return `${imgUrl}/vj.gif`;
      case 'jq':
        return `${imgUrl}/jq.gif`;
      case 'qh':
        return `${imgUrl}/qh.gif`;
      default:
        return `${imgUrl}/${value?.toLowerCase()}.gif`;
    }
  }
}
